module.exports = __webpack_public_path__ + "static/media/AmandatriceSq.cb051d50.jpg";